"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetFriends = useGetFriends;
var react_1 = require("react");
var i18n_1 = __importDefault(require("../i18n"));
var api_1 = require("../api");
var util_1 = require("../util");
var sentry_1 = require("../sentry");
var Permission_1 = require("../models/Permission");
function generateUsersInInstances(users) {
    var usersInInstances = {
        __private__: {
            __private__: {
                locationInfo: { permission: "private" },
                userIndexes: [],
            },
        },
    };
    for (var i = 0; i < users.length; ++i) {
        var user = users[i];
        if (!(0, Permission_1.isOnline)(user.locationInfo.permission))
            continue;
        if (user.locationInfo.worldId) {
            var locationInfo = user.locationInfo;
            var worldId = locationInfo.worldId;
            var instanceId = locationInfo.instanceId;
            if (!usersInInstances[worldId])
                usersInInstances[worldId] = {};
            if (!usersInInstances[worldId][instanceId])
                usersInInstances[worldId][instanceId] = { locationInfo: locationInfo, userIndexes: [] };
            usersInInstances[worldId][instanceId].userIndexes.push(i);
        }
        else {
            usersInInstances.__private__.__private__.userIndexes.push(i);
        }
    }
    if (!usersInInstances.__private__.__private__.userIndexes.length)
        delete usersInInstances.__private__;
    return usersInInstances;
}
var fetchUserProfilesPageSize = 500;
var getTypeFriends = function (state, setFriends, setLoading, setMax, fetchTypeFriends, online) { return __awaiter(void 0, void 0, void 0, function () {
    var users, maxSize, offset, fetchedUserIds_1, result, newUsers, _i, newUsers_1, user, profiles, _loop_1, i, userModels, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 8, 9, 10]);
                users = [];
                setLoading(true);
                maxSize = true;
                offset = 0;
                if (online) {
                    state.setOnlineFriendsInWorldInstanceIndexes({});
                }
                fetchedUserIds_1 = {};
                _a.label = 1;
            case 1:
                if (!(maxSize && offset <= 5000)) return [3 /*break*/, 3];
                return [4 /*yield*/, fetchTypeFriends(offset)];
            case 2:
                result = _a.sent();
                newUsers = (0, util_1.withLocationInfo)(result.users);
                // offsetに関わらず同じ値が返ってくる事象への対処
                if (newUsers.every(function (user) { return fetchedUserIds_1[user.id]; }))
                    return [3 /*break*/, 3];
                users.push.apply(users, newUsers.filter(function (user) { return !fetchedUserIds_1[user.id]; }));
                for (_i = 0, newUsers_1 = newUsers; _i < newUsers_1.length; _i++) {
                    user = newUsers_1[_i];
                    fetchedUserIds_1[user.id] = true;
                }
                setFriends(users);
                maxSize = Boolean(result.isMaxSize);
                offset += result.users.length;
                setMax(maxSize);
                return [3 /*break*/, 1];
            case 3:
                profiles = [];
                _loop_1 = function (i) {
                    var partialProfiles;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, (0, api_1.fetchProfilesByUsers)(users.slice(i, i + fetchUserProfilesPageSize), state)];
                            case 1:
                                partialProfiles = _b.sent();
                                profiles.push.apply(profiles, partialProfiles);
                                return [4 /*yield*/, state.backupDb.openDb().then(function (db) { return db.putUserProfiles(partialProfiles); })];
                            case 2:
                                _b.sent(); // 待たない
                                return [2 /*return*/];
                        }
                    });
                };
                i = 0;
                _a.label = 4;
            case 4:
                if (!(i < users.length)) return [3 /*break*/, 7];
                return [5 /*yield**/, _loop_1(i)];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                i += fetchUserProfilesPageSize;
                return [3 /*break*/, 4];
            case 7:
                userModels = (0, util_1.joinUserAndProfiles)(users, profiles);
                setFriends(userModels);
                if (online) {
                    state.setOnlineFriendsInWorldInstanceIndexes(generateUsersInInstances(userModels));
                }
                else {
                    state.setOnlineFriendsInWorldInstanceIndexes(generateUsersInInstances(state.onlineFriends.concat(userModels)));
                }
                state.dispatchNeedWorldIds({ operation: "push", ids: (0, util_1.userWorldIds)(users) });
                return [3 /*break*/, 10];
            case 8:
                e_1 = _a.sent();
                (0, sentry_1.captureException)(e_1);
                state.incrementErrorCount();
                alert("".concat(i18n_1.default.friends, "\n").concat(e_1));
                return [3 /*break*/, 10];
            case 9:
                setLoading(false);
                return [7 /*endfinally*/];
            case 10: return [2 /*return*/];
        }
    });
}); };
var getFavoriteFriends = function (state, afterOffline) { return __awaiter(void 0, void 0, void 0, function () {
    var favorites, e_2, onlineIds, offlineIds, existUsers_1, i, user, i, user, toFetchUserIds, fetchedUsers, i, user, e_3, fetchedProfiles_1, fetchedUserModels, i, user, favoriteGroups, _i, favorites_1, favorite, groupIndex, user, existUserIds, onlines, offlines, i, user, newOnlines, newOfflines, e_4;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 14, 15, 16]);
                state.setFavoriteFriendsLoading(true);
                favorites = void 0;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, api_1.fetchFavorites)("friend")];
            case 2:
                favorites = (_b.sent()).favorites;
                return [3 /*break*/, 4];
            case 3:
                e_2 = _b.sent();
                (0, sentry_1.captureException)(e_2);
                return [2 /*return*/];
            case 4:
                onlineIds = {};
                offlineIds = {};
                existUsers_1 = favorites.reduce(function (all, favorite) {
                    var _a;
                    return (__assign(__assign({}, all), (_a = {}, _a[favorite.favoriteId] = undefined, _a)));
                }, {});
                for (i = 0; i < state.onlineFriends.length; ++i) {
                    user = state.onlineFriends[i];
                    if (user.id in existUsers_1) {
                        existUsers_1[user.id] = user;
                    }
                    onlineIds[user.id] = true;
                }
                if (!afterOffline) return [3 /*break*/, 13];
                for (i = 0; i < state.offlineFriends.length; ++i) {
                    user = state.offlineFriends[i];
                    if (user.id in existUsers_1) {
                        existUsers_1[user.id] = user;
                    }
                    offlineIds[user.id] = true;
                }
                toFetchUserIds = Object.keys(existUsers_1).filter(function (id) { return !existUsers_1[id]; });
                fetchedUsers = [];
                i = 0;
                _b.label = 5;
            case 5:
                if (!(i < toFetchUserIds.length)) return [3 /*break*/, 10];
                _b.label = 6;
            case 6:
                _b.trys.push([6, 8, , 9]);
                return [4 /*yield*/, (0, api_1.fetchUserById)(toFetchUserIds[i], true)];
            case 7:
                user = _b.sent();
                if (user)
                    fetchedUsers.push(user);
                return [3 /*break*/, 9];
            case 8:
                e_3 = _b.sent();
                (0, sentry_1.captureException)(e_3);
                return [3 /*break*/, 9];
            case 9:
                ++i;
                return [3 /*break*/, 5];
            case 10: return [4 /*yield*/, (0, api_1.fetchProfilesByUsers)(fetchedUsers, state)];
            case 11:
                fetchedProfiles_1 = _b.sent();
                return [4 /*yield*/, state.backupDb.openDb().then(function (db) { return db.putUserProfiles(fetchedProfiles_1); })];
            case 12:
                _b.sent(); // 待たない
                fetchedUserModels = (0, util_1.joinUserAndProfiles)((0, util_1.withLocationInfo)(fetchedUsers), fetchedProfiles_1);
                for (i = 0; i < fetchedUserModels.length; ++i) {
                    user = fetchedUserModels[i];
                    if (user.id in existUsers_1) {
                        existUsers_1[user.id] = user;
                    }
                }
                _b.label = 13;
            case 13:
                favoriteGroups = [[], [], []];
                for (_i = 0, favorites_1 = favorites; _i < favorites_1.length; _i++) {
                    favorite = favorites_1[_i];
                    groupIndex = ["group_0", "group_1", "group_2"].indexOf(favorite.tags[0]);
                    user = existUsers_1[favorite.favoriteId];
                    if (user)
                        favoriteGroups[groupIndex].push(user);
                }
                state.setFavoriteFriends(favoriteGroups);
                state.setFavoriteFriendsMax(favoriteGroups.map(function () { return false; }));
                if (afterOffline) {
                    existUserIds = Object.keys(existUsers_1).filter(function (id) { return existUsers_1[id]; });
                    onlines = [];
                    offlines = [];
                    for (i = 0; i < existUserIds.length; ++i) {
                        user = existUsers_1[existUserIds[i]];
                        if ((0, Permission_1.isOnline)(user.locationInfo.permission)) {
                            if (!onlineIds[user.id]) {
                                onlines.push(user);
                            }
                        }
                        else if (!offlineIds[user.id]) {
                            offlines.push(user);
                        }
                    }
                    newOnlines = state.onlineFriends.concat(onlines);
                    newOfflines = state.offlineFriends.concat(offlines);
                    if (onlines.length) {
                        state.setOnlineFriends(newOnlines);
                    }
                    if (offlines.length) {
                        state.setOfflineFriends(newOfflines);
                    }
                    if (onlines.length || offlines.length) {
                        state.setOnlineFriendsInWorldInstanceIndexes(generateUsersInInstances(newOnlines.concat(newOfflines)));
                    }
                }
                state.dispatchNeedWorldIds({
                    operation: "push",
                    ids: (0, util_1.userWorldIds)((_a = []).concat.apply(_a, favoriteGroups)),
                });
                return [3 /*break*/, 16];
            case 14:
                e_4 = _b.sent();
                state.incrementErrorCount();
                (0, sentry_1.captureException)(e_4);
                alert("".concat(i18n_1.default.friends, "\n").concat(e_4));
                return [3 /*break*/, 16];
            case 15:
                state.setFavoriteFriendsLoading(false);
                return [7 /*endfinally*/];
            case 16: return [2 /*return*/];
        }
    });
}); };
var getUserNotes = function (state) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, replaceById, apply, offset, end, existIds, notes, updatedUserIds_1, _b, _loop_2, i, updatedUserIds, i;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (state.notesFetched)
                    return [2 /*return*/];
                state.setNotesLoading(true);
                _a = (0, util_1.applyToUserMany)(state), replaceById = _a.replaceById, apply = _a.apply;
                offset = 0;
                end = false;
                existIds = [];
                _c.label = 1;
            case 1:
                if (!(!end && offset <= 5000)) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, api_1.fetchUserNotes)(offset)];
            case 2:
                notes = _c.sent();
                existIds.push.apply(existIds, notes.map(function (note) { return note.targetUserId; }));
                _b = Set.bind;
                return [4 /*yield*/, (0, api_1.syncProfilePrivateMemo)(notes.map(function (note) { return ({ targetUserId: note.targetUserId, note: note.note }); }))];
            case 3:
                updatedUserIds_1 = new (_b.apply(Set, [void 0, _c.sent()]))();
                _loop_2 = function (i) {
                    var _d = notes[i], targetUserId = _d.targetUserId, note = _d.note;
                    var isUpdated = updatedUserIds_1.has(targetUserId);
                    replaceById(targetUserId, function (user) {
                        return isUpdated
                            ? __assign(__assign({}, user), { note: note, profile: __assign(__assign({ id: user.id }, user.profile), { privateMemo: note, privateMemoIsSynced: true }) }) : __assign(__assign({}, user), { note: note });
                    });
                };
                for (i = 0; i < notes.length; ++i) {
                    _loop_2(i);
                }
                end = Boolean(notes.length !== 100);
                offset += notes.length;
                return [3 /*break*/, 1];
            case 4: return [4 /*yield*/, (0, api_1.syncEndProfilePrivateMemo)(existIds)];
            case 5:
                updatedUserIds = _c.sent();
                for (i = 0; i < updatedUserIds.length; ++i) {
                    replaceById(updatedUserIds[i], function (user) { return (__assign(__assign({}, user), { note: "", profile: __assign(__assign({ id: user.id }, user.profile), { privateMemo: "", privateMemoIsSynced: true }) })); });
                }
                apply(state);
                state.setNotesLoading(false);
                state.setNotesFetched(true);
                return [2 /*return*/];
        }
    });
}); };
function useGetFriendsMain(state) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, e_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 20, , 21]);
                    _a = state.friendsLoadingState;
                    switch (_a) {
                        case "start": return [3 /*break*/, 1];
                        case "start-offline": return [3 /*break*/, 2];
                        case "online": return [3 /*break*/, 3];
                        case "favorite": return [3 /*break*/, 5];
                        case "offline": return [3 /*break*/, 7];
                        case "favorite-offline": return [3 /*break*/, 9];
                        case "favorite-offline-offline": return [3 /*break*/, 11];
                        case "user-notes": return [3 /*break*/, 13];
                        case "user-notes-offline": return [3 /*break*/, 15];
                        case "end": return [3 /*break*/, 17];
                        case "end-offline": return [3 /*break*/, 18];
                    }
                    return [3 /*break*/, 19];
                case 1:
                    state.setPlayerModerationsFetchRequest(true);
                    state.setFriendsFirstFetched(true);
                    state.setOnlineFriendsLoading(true);
                    // state.setOfflineFriendsLoading(true);
                    state.setFriendsLoadingState("online");
                    return [3 /*break*/, 19];
                case 2:
                    state.setPlayerModerationsFetchRequest(true);
                    state.setOfflineFriendsLoading(true);
                    state.setFriendsLoadingState("offline");
                    return [3 /*break*/, 19];
                case 3:
                    state.setFriendsLoadingState("wait");
                    return [4 /*yield*/, getTypeFriends(state, state.setOnlineFriends, state.setOnlineFriendsLoading, state.setOnlineFriendsMax, function (offset) { return (0, api_1.fetchFriends)(state, false, offset); }, true)];
                case 4:
                    _b.sent();
                    state.setFriendsLoadingState("favorite");
                    return [3 /*break*/, 19];
                case 5:
                    state.setFriendsLoadingState("wait");
                    return [4 /*yield*/, getFavoriteFriends(state, false)];
                case 6:
                    _b.sent();
                    state.setFriendsLoadingState("user-notes");
                    return [3 /*break*/, 19];
                case 7:
                    state.setFriendsLoadingState("wait");
                    return [4 /*yield*/, getTypeFriends(state, state.setOfflineFriends, state.setOfflineFriendsLoading, state.setOfflineFriendsMax, function (offset) { return (0, api_1.fetchFriends)(state, true, offset); }, false)];
                case 8:
                    _b.sent();
                    state.setFriendsLoadingState("user-notes-offline");
                    return [3 /*break*/, 19];
                case 9:
                    state.setFriendsLoadingState("wait");
                    return [4 /*yield*/, getFavoriteFriends(state, true)];
                case 10:
                    _b.sent();
                    state.setFriendsLoadingState("end");
                    return [3 /*break*/, 19];
                case 11:
                    state.setFriendsLoadingState("wait");
                    return [4 /*yield*/, getFavoriteFriends(state, true)];
                case 12:
                    _b.sent();
                    state.setFriendsLoadingState("end-offline");
                    return [3 /*break*/, 19];
                case 13:
                    state.setFriendsLoadingState("wait");
                    return [4 /*yield*/, getUserNotes(state)];
                case 14:
                    _b.sent();
                    state.setFriendsLoadingState("end");
                    return [3 /*break*/, 19];
                case 15:
                    state.setFriendsLoadingState("wait");
                    return [4 /*yield*/, getUserNotes(state)];
                case 16:
                    _b.sent();
                    state.setFriendsLoadingState("end-offline");
                    return [3 /*break*/, 19];
                case 17:
                    state.setFriendsFetchRestIntervalMax();
                    state.setFriendsLoadingState("wait");
                    return [3 /*break*/, 19];
                case 18:
                    state.setFriendsOfflineFetchRestIntervalMax();
                    state.setFriendsLoadingState("wait");
                    return [3 /*break*/, 19];
                case 19: return [3 /*break*/, 21];
                case 20:
                    e_5 = _b.sent();
                    state.incrementErrorCount();
                    (0, sentry_1.captureException)(e_5);
                    state.setFriendsLoadingState("end");
                    alert("".concat(i18n_1.default.friends, "\n").concat(e_5));
                    return [3 /*break*/, 21];
                case 21: return [2 /*return*/];
            }
        });
    });
}
function useGetFriends(state) {
    (0, react_1.useEffect)(function () {
        useGetFriendsMain(state);
    }, [state.friendsLoadingState]);
}
